import { AdminPage } from "@/components/admin/admin-page";

export default function AdminRoute() {
  return <AdminPage />;
}
